import { useMemo } from 'react';

import { useCohortDefinitionStore } from '@verantos-dev/app-state-cohort-definition';

/**
 * Returns true if any of the given concept group names were recently auto-applied
 * to the specified analytical variable.
 *
 * Used by CollapsibleLogicNode to auto-expand sections containing updated concept refs.
 */
export const useNodeHasRecentlyApplied = (avId: string, names: string[]): boolean => {
  const recentlyApplied = useCohortDefinitionStore((s) => s.recentlyAppliedConceptGroups);

  return useMemo(() => {
    const avEntries = recentlyApplied.filter((e) => e.avId === avId);
    if (avEntries.length === 0) return false;
    const appliedSet = new Set(avEntries.map((e) => e.conceptGroupName.toLowerCase()));
    return names.some((n) => appliedSet.has(n.toLowerCase()));
  }, [recentlyApplied, avId, names]);
};
